import { render, staticRenderFns } from "./ourProject.vue?vue&type=template&id=6605966a&"
import script from "./ourProject.vue?vue&type=script&lang=js&"
export * from "./ourProject.vue?vue&type=script&lang=js&"
import style0 from "./ourProject.vue?vue&type=style&index=0&id=6605966a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports